var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1Reservoir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.27 41.56A21.47 21.47 0 0153 56.71a21.12 21.12 0 01-30.09 0 21.53 21.53 0 010-30.3 18.81 18.81 0 017.13-4.21V17H28a2 2 0 110-4h6.06v12.14l-1.43.42a16.319 16.319 0 00-6.86 3.66 17.54 17.54 0 000 24.68 17.17 17.17 0 0024.41 0 17.59 17.59 0 003.7-19.13 17.331 17.331 0 00-3.71-5.55 15.63 15.63 0 00-6.73-3.66L42 25.14V13h6a2 2 0 010 4h-2v5.2a18.391 18.391 0 017 4.2c4 4.03 6.24 9.482 6.23 15.16h.04zm-33.82 2.7A12.66 12.66 0 1050.13 39H25.88a12.429 12.429 0 00-.43 5.26z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Reservoir.5c61a2bf.svg";
export { SvgD1Reservoir as ReactComponent };